import * as pt from "@cicada-lang/partech";
import {} from "../span/index.js";
export class Report extends Error {
    constructor(entries = []) {
        super();
        this.entries = entries;
    }
    format() {
        return this.entries
            .map(formatReportEntry)
            .map((s) => s.trim())
            .join("\n\n");
    }
    get message() {
        return this.format();
    }
}
function formatReportEntry(entry) {
    if (entry.context === undefined) {
        return entry.message;
    }
    else {
        return [
            entry.message,
            "",
            pt.report(entry.context.span, entry.context.text),
        ].join("\n");
    }
}
//# sourceMappingURL=Report.js.map